export interface AppConfig {
  APP_NAME: "Portal";
  APP_CLIENT_COOKIE_NAME: string;
  ENVIRONMENT: "Local" | "Integration" | "Staging" | "Production";
  API_URL: string;
  PUBLIC_API_URL: string;
  PRODUCTS_API_URL: string;
  PORTAL_URL: string;
  OLD_PORTAL_URL: string;
  LINK_URL: string;
  CONNECTOR_HEALTH_URL: string;
  IDENTITY_SERVER_URL: string;
  USER_MANAGEMENT_URL: string;
  USER_MANAGEMENT_API_URL: string;
  DATA_UI_URL: string;
  INTEGRATIONS_UI_URL: string;
  ASSESS_UI_URL: string;
  VISUALIZE_COMMERCE_URL: string;
  VISUALIZE_URL: string;
  AUTH_MODE: "cookie" | "sso";
  AMPLITUDE_API_KEY: string;
  DATADOG_PRIVACY_LEVEL: "allow" | "mask-user-input" | "mask";
  GA_TRACKING_ID_CONSOLIDATED_STREAM: string;
  GTM_ID: string;
  PARDOT_A_ID: string;
  PARDOT_C_ID: string;
  ZAPIER_TOKEN_MIGRATION_URL: string;
  ZAPIER_TRACK_BUILDING_URL: string;
  FEATURES_UI_URL: string;
  KNOWLEDGE_UI_URL: string;
  PRODUCT_PAGES_UI_URL: string;
  DATA_HISTORY_UI_URL: string;
  SYNCHRONIZATION_SETTINGS_UI_URL: string;
  CLIENT_CREDENTIALS_API_URL: string;
  PORTAL_API_URL: string;
  AUTH0_DOMAIN: string;
  AUTH0_CLIENTID: string;
}

interface ConfigWindow extends Window {
  AppConfig: AppConfig;
}

declare let window: ConfigWindow;

const config: AppConfig = window.AppConfig || {
  APP_NAME: "Portal",
  APP_CLIENT_COOKIE_NAME: "app-integration-clientid",
  ENVIRONMENT: "Integration",
  API_URL: "https://portal-api-integration.codat.io",
  PUBLIC_API_URL: "https://api-integration.codat.io",
  PRODUCTS_API_URL: "https://products-api-integration.codat.io",
  PORTAL_URL: "https://app-integration.codat.io",
  OLD_PORTAL_URL: "https://portal-integration.codat.io",
  LINK_URL: "https://link-integration.codat.io",
  CONNECTOR_HEALTH_URL: "https://connectorhealth-integration.codat.io",
  IDENTITY_SERVER_URL: "https://identity-integration.codat.io",
  USER_MANAGEMENT_URL: "https://users-integration.codat.io",
  USER_MANAGEMENT_API_URL: "https://users-api-integration.codat.io",
  DATA_UI_URL: "https://data-ui-integration.codat.io",
  FILES_UI_URL: "https://files-ui-integration.codat.io",
  INTEGRATIONS_UI_URL: "https://integrations-ui-integration.codat.io",
  PRODUCTS_UI_URL: "https://products-ui-integration.codat.io",
  ASSESS_UI_URL: "https://assess-ui-integration.codat.io",
  VISUALIZE_URL: "https://visualize-integration.codat.io",
  VISUALIZE_COMMERCE_URL: "https://visualize-commerce-integration.codat.io",
  AUTH_MODE: "sso",
  AMPLITUDE_API_KEY: "1c2a84301c15f56221a6f81af617f5f7",
  DATADOG_PRIVACY_LEVEL: "allow",
  GA_TRACKING_ID_CONSOLIDATED_STREAM: "213025502", // GA-provided test ID
  GTM_ID: "GTM-XXXXXXX",
  PARDOT_A_ID: "",
  PARDOT_C_ID: "",
  ZAPIER_TOKEN_MIGRATION_URL:
    "https://hooks.zapier.com/hooks/catch/659124/bq3cbss",
  ZAPIER_TRACK_BUILDING_URL:
    "https://hooks.zapier.com/hooks/catch/659124/bq3egwf",
  FEATURES_UI_URL: "https://features-client-integration.codat.io",
  KNOWLEDGE_UI_URL: "https://knowledge-integration.codat.io",
  PRODUCT_PAGES_UI_URL: "https://product-pages-ui-integration.codat.io",
  DATA_HISTORY_UI_URL: "https://data-history-integration.codat.io",
  SYNCHRONIZATION_SETTINGS_UI_URL:
    "https://synchronization-settings-integration.codat.io",
  CLIENT_CREDENTIALS_API_URL: "https://clientcredentials-integration.codat.io",
  PORTAL_API_URL: "https://portal-api-integration.codat.io",
  AUTH0_CLIENTID: "ZI6Rwgk2imDGDZ82PCQkLHJrZitJODOr",
  AUTH0_DOMAIN: "authentication-integration.codat.io",
};

export default config;
